import { ConfirmationDialogConfig } from "src/app/services/confirmation-dialog.service";
import { DeleteAction } from "./delete-action";


export class DeleteFileAction extends DeleteAction {
    /**
     * Default config for remove association confirmation dialog.
     */
    override confirmDialogConfig: ConfirmationDialogConfig = {
        title: "Elimina",
        message: "Sicuro di voler proseguire?",
        confirmButtonLabel: "Conferma",
        cancelButtonLabel: "Annulla",
        dialogSize: "sm",
    };

    override execute(val: any, row: any): void {
        const deleteFile = () => val.fileName;

        super.execute(val, row, deleteFile);
    }
}
